/**
 * @generated SignedSource<<5e3be95dd9be0fd4fab0ea09625e01b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgSpaceItem_storecastSpace$data = {
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"OrgSpaceItemInstalled_StorecastSpace" | "StorecastSpace_storecastSpace">;
  readonly " $fragmentType": "OrgSpaceItem_storecastSpace";
};
export type OrgSpaceItem_storecastSpace$key = {
  readonly " $data"?: OrgSpaceItem_storecastSpace$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgSpaceItem_storecastSpace">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgSpaceItem_storecastSpace",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorecastSpace_storecastSpace"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrgSpaceItemInstalled_StorecastSpace"
    }
  ],
  "type": "StorecastSpace",
  "abstractKey": null
};

(node as any).hash = "71ddb1ec5ab5e7ec4ac5c63e3cfeb554";

export default node;
